// extracted by mini-css-extract-plugin
export default {"Link":"Link-module__Link__sqfVJsx","Icon":"Link-module__Icon__Oh8XzpG"};